import Typography from '@mui/material/Typography';
import { PARTNER_TYPE_LABELS } from './utils/labels.ts';
import type { PartnerType } from './utils/partnerFeeRows.ts';

type PartnerTypeCaptionProps = {
  partnerType: PartnerType;
};

/** Says which kind of fee a partner row shows. Rendered only when a deal has both audience and contextual partners. */
export const PartnerTypeCaption = ({ partnerType }: PartnerTypeCaptionProps) => {
  return (
    <Typography
      data-test="partner-type"
      variant="body2"
      sx={{
        color: 'text.secondary',
        mb: 1.5,
      }}
    >
      {PARTNER_TYPE_LABELS[partnerType].caption}
    </Typography>
  );
};
